import { revokeAllImageUrls } from './imageUrls';

// Toda recarga automática del kiosco pasa por acá, para que un error en bucle no deje el
// iPad recargándose sin parar delante del cliente.

const RELOAD_LOG_KEY = 'kiosk-reloads';
const RELOAD_WINDOW_MS = 10 * 60 * 1000;
const MAX_RELOADS_PER_WINDOW = 3;

const readLog = () => {
  try {
    const raw = sessionStorage.getItem(RELOAD_LOG_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeLog = (log) => {
  try {
    sessionStorage.setItem(RELOAD_LOG_KEY, JSON.stringify(log));
  } catch (error) {
    // sessionStorage lleno o bloqueado: no es motivo para no recargar
  }
};

export const reloadKiosk = (reason) => {
  const now = Date.now();
  const recent = readLog().filter((time) => now - time < RELOAD_WINDOW_MS);

  if (recent.length >= MAX_RELOADS_PER_WINDOW) {
    console.log(`Se omite la recarga (${reason}): ya hubo ${recent.length} en los últimos 10 min.`);
    return false;
  }

  recent.push(now);
  writeLog(recent);

  console.log('Recargando el kiosco:', reason);
  revokeAllImageUrls();
  window.location.reload();
  return true;
};

// Reemplaza el window.onerror que estaba dentro del render de home.js (se reasignaba en cada
// render y recargaba ante cualquier error, sin tope).
export const installGlobalErrorReload = () => {
  window.addEventListener('error', (event) => {
    console.log('Error global detectado:', event.message);
    setTimeout(() => reloadKiosk('error global'), 2000);
  });

  // Las promesas rechazadas (típico: fetch sin internet) se registran pero NO recargan:
  // recargar por cada corte de red dejaría el kiosco en ciclo.
  window.addEventListener('unhandledrejection', (event) => {
    console.log('Promesa rechazada sin manejar:', event.reason);
  });
};
